// The public site is an early-beta funnel. Keep the destination centralized so
// every CTA reaches the same application form rather than a not-yet-live app.
export const BETA_URL = "/beta";

// The form posts to a narrow Cloudflare Worker. The Slack token remains a
// Worker secret and is never shipped to the browser.
export const WAITLIST_API_URL =
  (import.meta.env.VITE_WAITLIST_API_URL as string | undefined) ??
  "https://waitlist.kinsafe.ai";

// Public widget identifier. The matching secret exists only in the Worker.
export const TURNSTILE_SITE_KEY = "0x4AAAAAAD6ENtIeMfwcuBE6";

// The canonical apex (PRD §1.10.1-2). Used in copy/footers.
export const SITE_DOMAIN = "kinsafe.ai";
